import { Link } from "react-router-dom";
import { Shield, Twitter, Linkedin, Instagram } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#F8FAFC] border-t border-[#E2E8F0]">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-2">
              <Shield className="h-7 w-7 text-emerald-400" />
              <span className="text-xl font-bold text-[#0F172A]">CreatorVault</span>
            </Link>
            <p className="text-[#94A3B8] text-sm leading-relaxed">
              A product of Apex AI Labs LLC.
            </p>
          </div>

          {/* Product */}
          <div className="space-y-4">
            <h3 className="font-semibold text-[#0F172A] text-sm">Product</h3>
            <div className="space-y-3 text-sm">
              <Link to="/pricing" className="block text-[#64748B] hover:text-[#0F172A] transition-colors">Pricing</Link>
              <Link to="/case-studies" className="block text-[#64748B] hover:text-[#0F172A] transition-colors">Case Studies</Link>
              <Link to="/docs" className="block text-[#64748B] hover:text-[#0F172A] transition-colors">Docs</Link>
              <Link to="/contact" className="block text-[#64748B] hover:text-[#0F172A] transition-colors">Contact</Link>
            </div>
          </div>

          {/* Socials */}
          <div className="space-y-4">
            <h3 className="font-semibold text-[#0F172A] text-sm">Socials</h3>
            <div className="space-y-3 text-sm">
              <a href="https://twitter.com/creatorvault" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#64748B] hover:text-[#0F172A] transition-colors">
                <Twitter className="h-4 w-4" /> Twitter
              </a>
              <a href="https://linkedin.com/company/creatorvault" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#64748B] hover:text-[#0F172A] transition-colors">
                <Linkedin className="h-4 w-4" /> LinkedIn
              </a>
              <a href="https://instagram.com/creatorvault" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#64748B] hover:text-[#0F172A] transition-colors">
                <Instagram className="h-4 w-4" /> Instagram
              </a>
            </div>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h3 className="font-semibold text-[#0F172A] text-sm">Legal</h3>
            <div className="space-y-3 text-sm">
              <Link to="/terms-of-service" className="block text-[#64748B] hover:text-[#0F172A] transition-colors">Terms of Service</Link>
              <Link to="/privacy-policy" className="block text-[#64748B] hover:text-[#0F172A] transition-colors">Privacy Policy</Link>
              <Link to="/data-deletion" className="block text-[#64748B] hover:text-[#0F172A] transition-colors">Data Deletion</Link>
            </div>
          </div>
        </div>

        <div className="border-t border-[#E2E8F0] mt-12 pt-8 text-center">
          <p className="text-sm text-[#94A3B8]">
            © 2025 CreatorVault. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
